module.exports = __webpack_public_path__ + "img/woman-consultant.a13c1794.png";